import React from 'react';
import cloneDeep from 'lodash.clonedeep';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import { Row, Col, Badge, Form, FormGroup, Label, Input, Button,
  ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
  Media, Tooltip } from 'reactstrap';
import { FaCube, FaEdit, FaMicroscope, FaPuzzlePiece, FaVial, FaUsers, FaFlag, FaBook, FaDelicious,
  FaCalendarAlt, FaCubes, FaLink, FaList, FaEye, FaSearch } from 'react-icons/fa';

dayjs.extend(LocalizedFormat)

class VolumePanel extends React.Component {
  constructor(props) {
    super();
    this.state = {
      emdIndex: 0,
      editingName: false,
      nameSearching: '',
      showThumbImage: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.updateEMInfo(nextProps, this.state.emdIndex)
  }

  updateEMInfo(props, emdIndex) {
    let {
      dataListEMDs,
    } = props.base;
    this.currentEM = cloneDeep(dataListEMDs[emdIndex]);
  }

  toggleThumbImage = (() => {
    this.setState({
      showThumbImage: !this.state.showThumbImage
    });
  }).bind(this)

  viewEMD(emdIndex) {
    this.updateEMInfo(this.props, emdIndex);
    this.setState({emdIndex, editingName: false});
  }

  editName = (() => {
    this.setState({editingName: true, nameSearching: this.currentEM.n.slice(4)});
  }).bind(this);

  searchName = (() => {
    let {
      dataListEMDs,
    } = this.props.base;
    let index = dataListEMDs.findIndex(d => +this.state.nameSearching === +d.n.slice(4));
    if(index >= 0)
      this.viewEMD(index);
  }).bind(this);

  tagJoin(arr, sep) {
    let arr1 = []
    for(let i=0; i<arr.length; ++i) {
      arr1.push(arr[i]);
      arr1.push(sep);
    }
    return arr1;
  }

  render() {
    let {
      listEMMethod,
      listComponentType,
      listOrganism,
      listAuthorFull,
      listTeam,
      listEMDBStatus,
      listPapers,
      listPublication,
      dataListEMDs,
    } = this.props.base;
    if(!this.currentEM)
      return (<div />)
    let emdNumber = this.currentEM.n.slice(4);
    return (
      <Media>
        <Media body>
          {this.state.editingName ? <Row>
            <Label for='name' sm={3}><h4><FaCube size='1.2em' />{' EMD-'}</h4></Label>
            <Col sm={3}>
              <Input
                type='number'
                size='sm'
                name='name'
                onChange={(e) => {
                  this.setState({nameSearching: e.target.value});
                }}
                value={this.state.nameSearching}
              />
            </Col>
            <Col sm={6}>
              <Button size="sm" onClick={this.searchName}><FaSearch /></Button>
            </Col>
          </Row> : <Media heading id='emdtitle'>
            <FaCube size='1.2em' />{` ${this.currentEM.n.toUpperCase()} `}
            <small>
            <Badge className='handcursor' onClick={this.editName}><FaEdit /></Badge>
            </small>
            <Tooltip
              placement="right"
              isOpen={this.state.showThumbImage}
              target="emdtitle"
              toggle={this.toggleThumbImage}
            >
              <Media object
                src={`https://www.emdataresource.org/gifs/400_${emdNumber}.gif`}
                alt="thumb image"
                width={400}
              />
            </Tooltip>
          </Media>}
          <FaMicroscope size='1.2em' />{' '}
          <Badge
            className='handcursor'
            onClick={() => this.props.onEMMethodDrilled(this.currentEM.m)}
          >{listEMMethod[this.currentEM.m].name}</Badge><br />
          <FaPuzzlePiece size='1.2em' /> {this.tagJoin(this.currentEM.c.map(c => ({...listComponentType[c], id:c})).map(d => (
            <Badge
              className='handcursor'
              onClick={() => this.props.onComponentDrilled(d.id)}
            >{d.name}</Badge>
          )), ' ')}<br />
          <FaVial size='1.2em' /> {this.tagJoin(this.currentEM.o.map(o => ({...listOrganism[o], id:o})).map(d => (
            <Badge
              className='handcursor'
              onClick={() => this.props.onOrganismDrilled(d.id)}
            >{d.name}</Badge>
          )), ' ')}<br />
          {this.currentEM.f.length !== 0 && <div>
            <FaUsers size='1.2em' /> {
              this.tagJoin(this.currentEM.f.map(f => ({...listAuthorFull[f], id: f})).map(d => (
                <Badge
                  className='handcursor'
                  color={(d.leading >= 0) ? this.currentEM.u.indexOf(d.leading) < 0 ? "primary" : "success" : "secondary"}
                  onClick={() => this.props.onAuthorDrilled(d.id)}
                >{d.name}</Badge>
              )), ' ')
            }<br />
          </div>}
          <FaFlag size='1.2em' />{' '}
          <Badge
            className='handcursor'
            onClick={() => this.props.onEMDBStatusDrilled(this.currentEM.s)}
          >{listEMDBStatus[this.currentEM.s].name}</Badge><br />
          {listPublication[this.currentEM.p] && <div><FaBook size='1.2em' />{' '}
          {listPapers[this.currentEM.d].title} ({listPapers[this.currentEM.d].count}){' '}
          <Badge
            className='handcursor'
            onClick={() => this.props.onPublicationDrilled(this.currentEM.p)}
          >{listPublication[this.currentEM.p].name}</Badge>{' '}
          <Badge
            className='handcursor'
            onClick={() => this.props.onPaperDrilled(this.currentEM.d)}
          >DOI: {listPapers[this.currentEM.d].id.slice(4)}</Badge><br /></div>}
          <FaDelicious size='1.2em' /> {this.currentEM.r ? this.currentEM.r + 'Å' : 'unknown'}<br />
          <FaCalendarAlt size='1.2em' /> {dayjs(this.currentEM.t).format('ll')}<br />
          <FaCubes size='1.2em' /> {`${this.currentEM.g[0]}×${this.currentEM.g[1]}×${this.currentEM.g[2]}`}<br />
          <FaLink size='1.2em' />{' '}
          <Badge color="success" style={{display:"none"}} target="about:blank" href={`https://www.emdataresource.org/${this.currentEM.n.toUpperCase()}`}><FaList /> EMDB</Badge>{' '}
          <Badge color="success" target="about:blank" href={`http://www.emdb-china.org.cn/data?code=${this.currentEM.n.toUpperCase()}`}><FaList /> EMDB-CN</Badge>{' '}
          <Badge color="success" target="about:blank" href={`http://v.emdb-china.org.cn/EMDB?${this.currentEM.n.toUpperCase()}`}><FaEye /> Visualization</Badge>
        </Media>
      </Media>
    )
  }
}

export default VolumePanel;
